import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const MessageIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M7.5 17.2507C8.74219 17.2507 9.75 18.2586 9.75 19.5008V20.2509L13.1484 17.7008C13.5375 17.4101 14.0109 17.2507 14.4984 17.2507L21 17.2507C21.4125 17.2507 21.75 16.9132 21.75 16.5007L21.75 3.00013C21.75 2.58761 21.4125 2.2501 21 2.2501L3 2.2501C2.5875 2.2501 2.25 2.58761 2.25 3.00013L2.25 16.5007C2.25 16.9132 2.5875 17.2507 3 17.2507H7.5ZM9.75 23.0635L9.74063 23.0729L9.50156 23.251L8.7 23.851C8.475 24.0198 8.17031 24.0479 7.9125 23.9213C7.65469 23.7948 7.5 23.537 7.5 23.251V22.2525V21.9525V21.9384V21.7509V19.5008H5.25H3C1.34531 19.5008 0 18.1555 0 16.5007L0 3.00013C0 1.34537 1.34531 0 3 0L21 0C22.6547 0 24 1.34537 24 3.00013L24 16.5007C24 18.1555 22.6547 19.5008 21 19.5008L14.4984 19.5008L9.75 23.0635Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default MessageIcon
